import React from 'react'
import analytics from '../analytics'

export default function useGoogleAnalytics() {
  React.useEffect(() => {
    analytics.init()
  }, [])
}
